import { render, staticRenderFns } from "./HowToBuy.vue?vue&type=template&id=5b4d08c0&scoped=true&"
import script from "./HowToBuy.vue?vue&type=script&lang=js&"
export * from "./HowToBuy.vue?vue&type=script&lang=js&"
import style0 from "./HowToBuy.vue?vue&type=style&index=0&id=5b4d08c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4d08c0",
  null
  
)

export default component.exports